<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="AddEmplacement" :validation-schema="emplacementSchema">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="parent" class="form-label fw-medium text-black">
                Emplacement Parent
              </label>
              <Field name="parent" v-model="parent" class="form-control shadow-none fs-md-15 text-black"
                v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :filter-results="false" :min-chars="2"
                  :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300" :options="async (query) => {
                    if (query.length >= 3) {
                      const results = await reupererContrat(query);
                      if (results && results.length > 0) {
                        return results;
                      } else {
                        return [
                          { value: '', label: 'Aucun enregistrement trouvé' },
                        ];
                      }
                    } else {
                      return [];
                    }
                  }
                    " noOptionsText="Tapez au moins deux caractères" placeholder="Rechercher un contrat" />
              </Field>
              <ErrorMessage name="parent" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Nouveau code <span class="text-danger"></span>
              </label>
              <Field name="ncode" type="text" v-model="ncode" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Nouveau code" />
              <ErrorMessage name="ncode" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black"> Secteur </label>
              <Field name="secteur" v-slot="{ field }" v-model="secteur">
                <Multiselect :options="secteurs" :searchable="true" v-model="field.value" v-bind="field"
                  placeholder="Sélectionner un secteur" />
              </Field>
              <ErrorMessage name="secteur" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Type emplacement
              </label>
              <Field name="typeEmplacement" v-slot="{ field }" v-model="typeEmplacement">
                <Multiselect :options="types" :searchable="true" v-model="field.value" v-bind="field"
                  placeholder="Sélectionner un type emplacement" />
              </Field>
              <ErrorMessage name="typeEmplacement" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Taxe mensuelle <span class="text-danger"></span>
              </label>
              <Field name="taux" v-model="taux" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Taux" />
              <ErrorMessage name="taux" class="text-danger" />
            </div>
          </div>

          <div class="col-md-6 col-xl-6 col-xm-12">
            <label for="contrat" class="form-label fw-medium text-black">
              <span> Locataire</span>
              <span>
                <a v-if="checkPrivilege('AddUsager')" href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal"
                  @click="ajouterUsager" type="button"><span class="badge text-bg-success"
                    style="margin-left: 0.3em">A</span></a>
                <a href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal" @click="modifUsager"
                  type="button"><span class="badge text-bg-secondary ml-5" style="margin-left: 0.3em">M</span></a>
              </span>
            </label>
            <Field name="locataire" v-model="locataire" class="form-control shadow-none fs-md-15 text-black"
              v-slot="{ field }">
              <Multiselect v-model="field.value" v-bind="field" :filter-results="false" :min-chars="2"
                :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300" :options="async (query) => {
                  return fetchLocataireOptions(query);
                }
                  " noOptionsText="Tapez au moins deux caractères" placeholder="Rechercher un locataire" />
            </Field>
            <ErrorMessage name="locataire" class="text-danger" />
          </div>
          <div class="col-md-6 col-xl-6 col-xm-12">
            <label for="contrat" class="form-label fw-medium text-black">
              <span> Exploitant</span>
              <span>
                <a v-if="checkPrivilege('AddUsager')" href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal"
                  @click="ajouterUsager1" type="button"><span class="badge text-bg-success"
                    style="margin-left: 0.3em">A</span></a>
                <a href="#" data-bs-toggle="modal" data-bs-target="#AddUsagerModal" @click="modifUsager1"
                  type="button"><span class="badge text-bg-secondary ml-5" style="margin-left: 0.3em">M</span></a>
              </span>
            </label>
            <Field name="exploitant" v-model="exploitant" class="form-control shadow-none fs-md-15 text-black"
              v-slot="{ field }">
              <Multiselect v-model="field.value" v-bind="field" :filter-results="false" :min-chars="2"
                :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300" :options="async (query) => {
                  if (query && query.length >= 3) {
                    const results = await reupererUsagers(query);
                    if (results && results.length > 0) {
                      return results;
                    } else if (results.length >= 3) {
                      return [
                        {
                          value: '',
                          label: 'Aucun enregistrement trouvé',
                        },
                      ];
                    } else {
                      return [];
                    }
                  }
                }
                  " noOptionsText="Tapez au moins deux caractères" placeholder="Rechercher un exploitant" />
            </Field>
            <ErrorMessage name="exploitant" class="text-danger" />
          </div>

          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black"> Activite </label>
              <Field name="activite" v-slot="{ field }" v-model="activite">
                <Multiselect :options="activites" :searchable="true" v-model="field.value" v-bind="field"
                  placeholder="Sélectionner une activité" />
              </Field>
              <ErrorMessage name="activite" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label class="form-label fw-medium text-black">
                Plus detail activité <span class="text-danger"></span>
              </label>
              <Field name="nouveau_activite" v-model="nouveau_activite"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Tomate" />
              <ErrorMessage name="nouveau_activite" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button class="btn btn-success me-3" type="submit">
                Ajouter emplacement
              </button>
              <router-link to="/liste-emplacement" class="btn btn-danger"><i
                  class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
  <AddUsagerModal :item="selectedItem" @close="recharger" @open="show_Modal" />
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import ApiService from "@/services/ApiService";
import { useRouter } from "vue-router";
import Multiselect from "@vueform/multiselect";
import axios, { AxiosError } from "axios";
import AddUsagerModal from "./Usager.vue";
import { hideModal, showModal, success, error, checkPrivilege } from "@/utils/utils";

export default defineComponent({
  name: "AddEmplacement",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    AddUsagerModal,
  },
  props: {
    item: {
      type: String,
      required: true,
    },
  },
  setup: (props, { emit }) => {
    const emplacementSchema = Yup.object().shape({
      parent: Yup.number().notRequired(),
      locataire: Yup.string().required("Le locataire est obligatoire"),
      exploitant: Yup.string().required("Le exploitant est obligatoire"),
      ncode: Yup.string().required("Le nouveau code est obligatoire"),
      secteur: Yup.string().required("Le secteur est obligatoire"),
      taux: Yup.string().required("Le sexe est obligatoire"),
      typeEmplacement: Yup.string().required("Le sexe est obligatoire"),
      activite: Yup.string().required("L'activité est obligatoire"),
      nouveau_activite: Yup.string().notRequired(),
    });
    const emplacementForm = ref(null);
    const code = ref();
    const reference = ref();
    const superficie = ref();
    const marche = ref();
    const npi = ref();
    const categorieActivite = ref();
    const type = ref();
    const statut = ref();
    const categorieActiviteOptions = ref();
    const marcheOptions = ref();
    const typeOptions = ref();
    const router = useRouter();
    const emplacement = ref();
    const nouveau_activite = ref();
    const ncode = ref();
    const secteur = ref();
    const secteurs = ref();
    const types = ref();
    const locataire = ref();
    const taux = ref();
    const typeEmplacement = ref();
    const exploitant = ref();
    const activite = ref();
    const selectedItem = ref();
    const matricule = ref();
    const UpEmplacementModalRef = ref<null | HTMLElement>(null);
    const parent = ref();
    const sexes = ref([
      { value: "Masculin", label: "Masculin" },
      { value: "Féminin", label: "Féminin" },
      { value: "Autre", label: "Autre" },
    ]);
    const usagerForm = ref<any | null>(null);

    const ajouterUsager = () => {
      selectedItem.value = null;
    };

    const modifUsager = () => {
      selectedItem.value = locataire.value;
    };

    const ajouterUsager1 = () => {
      selectedItem.value = null;
    };

    const recharger = () => {
      //console.log("Oui c'est bon");
    };

    const modifUsager1 = () => {
      selectedItem.value = exploitant.value;
    };

    const reupererUsagers = async (recherche) => {
      try {
        const response = await ApiService.post("getUsagerByKey", { recherche });
        if (response.data) {
          return response.data.data.map((el) => {
            return {
              value: el.matricule,
              label: `${el.matricule} || ${el.nom}  ${el.prenom}  ${el.tel ? " - " + el.tel : ""
                }`,
            };
          });
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const resetForm = () => {
      locataire.value = null;
      exploitant.value = null;
      ncode.value = null;
      secteur.value = null;
    };
    const locataires = ref<Array<any>>([]);
    const exploitants = ref<Array<any>>([]);

    const fetchLocataireOptions = async (query: any = null) => {
      if (query && query.length >= 3) {
        const results = await reupererUsagers(query);
        if (results && results.length > 0) {
          return results;
        } else {
          return [
            {
              value: "",
              label: "Aucun enregistrement trouvé",
            },
          ];
        }
      }
      if (query == null) {
        return locataires.value;
      }
      return [];
    };

    const fetchExploitantOptions = async (query: any = null) => {
      if (query && query.length >= 3) {
        const results = await reupererUsagers(query);
        if (results && results.length > 0) {
          return results;
        } else {
          return [
            {
              value: "",
              label: "Aucun enregistrement trouvé",
            },
          ];
        }
      }
      if (query == null) {
        return exploitants.value;
      }
      return [];
    };
    const getUsager = async (matricule: string) => {
      try {
        const response = await axios.get(`emplacement/${matricule}`);
        if (response.data.data) {
          const lusager = response.data.data;
          ncode.value = lusager.ncode_emp;
          secteur.value = lusager?.secteur?.code_secteur;
          typeEmplacement.value = lusager?.type_emplacement?.id;
          taux.value = lusager.montant_location;

          if (lusager?.exploitant) {
            locataires.value = [
              {
                value: lusager.locataire?.matricule,
                label: `${lusager.locataire?.matricule} || ${lusager.locataire?.nom
                  }  ${lusager.locataire?.prenom}  ${lusager.locataire?.tel ? " - " + lusager.locataire?.tel : ""
                  }`,
              },
            ];
          }

          if (lusager?.exploitant) {
            exploitants.value = [
              {
                value: lusager.exploitant?.matricule,
                label: `${lusager.exploitant?.matricule} || ${lusager.exploitant?.nom
                  }  ${lusager.exploitant?.prenom}  ${lusager.exploitant?.tel ? " - " + lusager.exploitant?.tel : ""
                  }`,
              },
            ];
          }
          fetchExploitantOptions(null);
          fetchLocataireOptions(null);
          exploitant.value = lusager?.exploitant?.matricule;
          locataire.value = lusager.locataire?.matricule;
        } else {
          error("Erreur lors de la récupération de l'usager");
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const activites = ref([]);
    const reupererActivite = async () => {
      try {
        const response = await ApiService.get("listeActivite");
        if (response.data) {
          return (activites.value = response.data.data.map((el) => {
            return {
              value: el.activite_nom,
              label: el.activite_nom,
            };
          }));
        }
      } catch (err) {
        error(err);
      }
    };

    const reupererTypeEmplacement = async () => {
      try {
        const response = await ApiService.get("all/type/emplacement");
        if (response.data) {
          return (types.value = response.data.data.map((el) => {
            return {
              value: el.id,
              label: el.libelleTypeEmp,
            };
          }));
        }
      } catch (err) {
        //console.log("Err ===> ", err);
        error(err);
      }
    };

    const reupererSecteur = async () => {
      try {
        const response = await ApiService.get("all/secteur");
        if (response.data) {
          return (secteurs.value = response.data.data.map((el) => {
            return {
              value: el.code_secteur,
              label: el.libelle_secteur,
            };
          }));
        }
      } catch (err) {
        //"Err ===> ", err);
        error(err);
      }
    };
    onMounted(async () => {
      await reupererTypeEmplacement();
      await reupererSecteur();
      await reupererActivite();
    });

    const reupererContrat = async (recherche) => {
      try {
        const response = await ApiService.post("listeContrat", { recherche });
        if (response.data) {
          return (response.data.data.map((el) => {
            return {
              value: el.id,
              label:
                el.ref + " - Lo : " + el.locataire + `${el.exploitant ? " - Ex : "+el.exploitant : ""}`,
            };
          }));
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const AddEmplacement = async (values, { resetForm }) => {
      ApiService.post("/emplacements", values)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeEmplacementPage" });
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    const show_Modal = (el) => {
      showModal(el);
      selectedItem.value = 0;
    };

    return {
      reupererContrat,
      parent,
      emplacementSchema,
      AddEmplacement,
      emplacementForm,
      categorieActivite,
      categorieActiviteOptions,
      marche,
      type,
      marcheOptions,
      typeOptions,
      statut,
      recharger,
      fetchExploitantOptions,
      fetchLocataireOptions,
      modifUsager,
      ajouterUsager,
      modifUsager1,
      ajouterUsager1,
      reupererUsagers,
      emplacement,
      secteur,
      secteurs,
      ncode,
      sexes,
      reupererTypeEmplacement,
      reupererSecteur,
      taux,
      locataires,
      exploitants,
      typeEmplacement,
      reupererActivite,
      UpEmplacementModalRef,
      exploitant,
      locataire,
      types,
      matricule,
      usagerForm,
      activites,
      activite,
      selectedItem,
      nouveau_activite,
      show_Modal,
      checkPrivilege
    };
  },
});
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
